import React from "react";
import "./style.scss";
import { useDispatch } from "react-redux";
import { AGGREGATOR_FEATURES_MAP } from "../../../data/outlet-status-constants";
import { getHelpCentreLink } from "../../../redux/slices";
import OutletLogisticStatus from "./outlet-logistic-status-modal";
import SelfDeliveryCharge from "./self-delivery-charge-modal";
import DeliveryTimings from "./delivery-timings-modal";
import OutletConfigurationEditModal from "../outlet-configurations-edit-modal";

interface Props {
  moreOptionsMenuData: any;
  updateMoreOptionsMenuData: any;
  clearMoreOptionsMenuData: any;
  setApiStateModalData: any;
}

const RenderSelectedOption = (props: Props) => {
  const {
    moreOptionsMenuData,
    clearMoreOptionsMenuData,
    setApiStateModalData,
  } = props;
  const { outletData, selectedOptionId } = moreOptionsMenuData;
  const dispatch = useDispatch();

  const commonProps = {
    moreOptionsMenuData,
    onModalClose: clearMoreOptionsMenuData,
    setApiStateModalData,
  };

  function redirectToHelpCentre() {
    let dataToPost = {
      outletId: outletData?.id,
      brid: outletData?.brid,
      type: outletData?.type,
    };
    const callback = (success: boolean, response: any = {}) => {
      if (success) {
        response?.helpURL &&
          window.open(response?.helpURL, "_blank", "noopener,noreferrer");
      }
      clearMoreOptionsMenuData();
    };
    dispatch(getHelpCentreLink({ dataToPost, callback }));
  }

  function renderSelectedOption() {
    switch (selectedOptionId) {
      case AGGREGATOR_FEATURES_MAP.help_centre.id:
        redirectToHelpCentre();
        return <></>;
      case AGGREGATOR_FEATURES_MAP.outlet_logistic_status.id:
        return <OutletLogisticStatus {...commonProps} />;
      case AGGREGATOR_FEATURES_MAP.self_delivery_charge.id:
        return <SelfDeliveryCharge {...commonProps} />;
      case AGGREGATOR_FEATURES_MAP.delivery_timings.id:
      case AGGREGATOR_FEATURES_MAP.self_delivery_timings.id:
        return <DeliveryTimings {...commonProps} />;
      case AGGREGATOR_FEATURES_MAP.edit_configuration.id:
        return (
          <OutletConfigurationEditModal {...commonProps} isEditMode={true} />
        );
      default:
        clearMoreOptionsMenuData();
        return <></>;
    }
  }
  return renderSelectedOption();
};

export default RenderSelectedOption;
